import request from '@/utils/request'

/**
 * 获取管理员拼团列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function listAdminProductGroup(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.listAdminProductGroup',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}